import { Link } from 'react-router-dom';
import { Box, Flex, FlexProps, Image } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import shieldImg from 'assets/brand/shield@2x.png';
import locales from './locales';

const UpgradeSection = (props: FlexProps) => {
  return (
    <Flex alignItems="center" flexDir="column" textAlign="center" {...props}>
      <Image
        marginBottom="space-16"
        boxSize="90px"
        alt=""
        role="presentation"
        src={shieldImg}
      />

      <Heading paddingBottom="space-8">{locales.title}</Heading>

      <Text paddingBottom="space-24">{locales.description}</Text>

      <Button as={Link} icon="star" iconPosition="left" to="/upgrade/choice">
        {locales.cta}
      </Button>
    </Flex>
  );
};

export default UpgradeSection;
